
import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-training-compliance-summary',
  templateUrl: './training-compliance-summary.component.html',
  styleUrls: ['./training-compliance-summary.component.css']
})
export class TrainingComplianceSummaryComponent implements OnChanges {
  @Input() TrainingComplianceSummaryData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  rows : any[];
  cols: any[] = [];
  header: any[] = [];
  clonedData:any[]=[];
  IsEdit:boolean = false;
  ComplianceSummaryData : any;
  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnChanges(): void {
    if(this.TrainingComplianceSummaryData){
        this.cols = [];
        this.rows = [];
        this.header = [];
        this.header = this.TrainingComplianceSummaryData[0].Headers;
        this.rows = this.TrainingComplianceSummaryData[0].Rows;
        if(this.header){
          this.header.forEach(element => {
            this.cols.push({'field': this.header.indexOf(element),'header':element })
          });
        }
        if(this.rows){
          this.rows.forEach((element,index) => {
            element.Id = index+1;
          });
        }
    }
  }

  onRowEditInit(data: any) {
    this.clonedData[data.Id] = { ...data };
  }

  onRowEditSave(data: any,ri:number) {
    if (data.Id > 0) {
      if(this.clonedData){
        data.forEach((element,index) => {
          if(index != 0){
            if(data[index] != this.clonedData[data.Id][index]){
              this.rows[this.rows.length - 1][index] = this.rows[this.rows.length - 1][index] - this.clonedData[data.Id][index] + data[index]
            }
          }
        });
        this.clonedData = [];
      }
    }
  }

  onRowEditCancel(data: any, index: number) {
    this.clonedData = [];
  }

  GetTrainingComplianceSummarySelectedDetails(rowdata,col){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Training Compliance Summary",
        "Component":rowdata[1] === "Total" || rowdata[1] === "" || rowdata[1] === null ? 0 : rowdata[0],
         "Column":col.field,
        "ColumnName":col.header
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetTrainingComplianceSummarySelectedDetails.bind(this));
  }
  callbackMethodForGetTrainingComplianceSummarySelectedDetails(response){
    if(response.Success)
    this.ComplianceSummaryData = response.Result;
  }

  Redirect(value,UnitId)
  {
  this.router.navigate(['/tnc/assign-training/', value, { unitId:UnitId }])
  }
  
  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('TrainingComplianceSummaryTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  //ws['!ref'] = ws['!ref'].replace('T','S');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "TrainingComplianceSummary.xlsx");

  }
  //EOC Pritesh

}
